/** Test account that can see Result/View before results announce date. */
export const EARLY_RESULT_VIEW_TEST_EMAIL = 'a6@test.com'

export function shouldShowResultViewEarly(loginEmail) {
    if (!loginEmail) {
        return false
    }
    return String(loginEmail).trim().toLowerCase() === EARLY_RESULT_VIEW_TEST_EMAIL.toLowerCase()
}
